import { render, staticRenderFns } from "./ArticleDefault.vue?vue&type=template&id=d4ba3fae&scoped=true"
import script from "./ArticleDefault.vue?vue&type=script&lang=js"
export * from "./ArticleDefault.vue?vue&type=script&lang=js"
import style0 from "./ArticleDefault.vue?vue&type=style&index=0&id=d4ba3fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ba3fae",
  null
  
)

export default component.exports